<template>
    <div class="background_fader">
        <transition-group name="background-fade">
            <div
                class="background_image"
                v-for="(image, index) in content"
                :key="'image-' + index"
                v-show="active == index"
                :style="{'background-image': `url(${require('@/assets/images/stage_backgrounds/' + image)})`}"
            />
        </transition-group>
    </div>
</template>

<script>
export default {
    name: 'BackgroundFader',
    props: ['content', 'delay'],
    data() {
        return {
            active: 0,
            interval: null,
            timer: 1000,
        }
    },
    methods: {
        loadTimer() {
            this.timer = this.delay || this.timer
        },
        start() {
            this.interval = setInterval(() => {
                if (this.active == this.content.length-1) {
                    this.clear()
                    this.$emit('complete')
                } else {
                    this.active++
                }
                // this.active++
                // if (this.active == this.content.length - 1) {
                //     this.clear()
                //     this.$emit('complete')
                // }
            }, this.timer)
        },
        reset() {
            this.clear()
            this.active = 0
            this.start()
        },
        clear() {
            clearInterval(this.interval)
        },
    },
    mounted() {
        this.loadTimer()
        this.start()
    },
    beforeDestroy() {
        this.clear()
    },

}
</script>

<style lang="scss" scoped>

.background_fader {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
}

.background_image {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

$bgTrans: .25s;

.background-fade- {
    &enter-active, &leave-active {
        transition: opacity $bgTrans linear;
    }
    &leave-active {
        transition-delay: $bgTrans;
    }
    &enter, &leave-to {
        opacity: 0;
    }
}

</style>
